import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../shared/common.styles'

export const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),
  title: {
    fontSize: 40,
    fontFamily: 'GothamRounded',
    lineHeight: 1,
    fontWeight: 450,
    letterSpacing: 'normal',
    textAlign: 'center',
    margin: [20, 0],
    [theme.media.mobile]: {
      margin: [10, 20]
    },
    [theme.media.smallMobile]: {
      margin: [10, 20],
      fontSize: 32
    }
  },

  subTitle: {
    fontSize: 18,
    fontFamily: 'GTWalsheim',
    lineHeight: 1,
    fontWeight: 500,
    letterSpacing: 'normal',
    textAlign: 'center',
    marginTop: 0,
    [theme.media.mobile]: {
      margin: [0, 20]
    },
    [theme.media.smallMobile]: {
      fontSize: 16,
      margin: [0, 20],
      lineHeight: '18px'
    }
  },

  grid: {
    maxWidth: 1400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexFlow: 'row wrap'
  },

  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 10,
    marginBottom: 20,
    [theme.media.desktop]: {
      marginTop: 25,
      marginBottom: 45
    }
  },

  buttonWrapper: {
    display: 'flex',
    padding: [0, 20],
    [theme.media.smallMobile]: {
      width: '100%'
    }
  },

  button: {
    minWidth: 437,
    marginTop: 35,
    [theme.media.mobile]: {
      minWidth: 240
    },
    [theme.media.smallMobile]: {
      minWidth: 240
    }
  },

  loadMoreButton: {
    marginBottom: -15
  }
}))
